import React, { useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Modal,
  Button,
} from "@mui/material";
import img5 from "../img/1 (1).jpeg";
import img6 from "../img/1 (2).jpeg";
import img7 from "../img/1 (3).jpeg";

const courses = [
  { id: 1, title: "वर्तमान निर्णय अंक 10 वा", image: img5 },
  { id: 3, title: "वर्तमान निर्णय अंक 11 वा", image: img7 },

  { id: 2, title: "वर्तमान निर्णय अंक 12 वा", image: img6 },
];

const VartmanNiryanCards = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 2,
        flexWrap: "wrap",
        p: 2,
      }}
    >
      {courses.map((course) => (
        <Card key={course.id} sx={{ width: 280, boxShadow: 3, borderRadius: 2 }}>
          <CardMedia
            component="img"
            height="250"
            image={course.image}
            alt={course.title}
            sx={{
              objectFit: "cover",
              cursor: "pointer",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
            onClick={() => setSelectedImage(course.image)}
          />
          <CardContent>
            <Typography variant="h6" textAlign="center">
              {course.title}
            </Typography>
          </CardContent>
        </Card>
      ))}

      {/* Image Modal */}
      <Modal open={!!selectedImage} onClose={() => setSelectedImage(null)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            width: "auto",
            maxWidth: "90vw", // Limits width to prevent excess white space
            maxHeight: "90vh", // Ensures modal does not get too tall
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={selectedImage}
            alt="Full View"
            style={{
              width: "100%", // Ensures it scales properly
              maxWidth: "80vw", // Adjust for large screens
              height: "auto", // Maintains aspect ratio
              maxHeight: "80vh",
              objectFit: "contain",
              display: "block",
            }}
          />
          <Button
            sx={{ mt: 2, alignSelf: "center" }}
            variant="contained"
            color="primary"
            onClick={() => {
              const link = document.createElement("a");
              link.href = selectedImage;
              link.download = "download.jpg";
              link.click();
            }}
          >
            Download
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default VartmanNiryanCards;
